// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://unpkg.com/video.js/dist/video-js.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-dc2f3a3e] .vjs-play-progress{background:var(--v-accentPurpleAccessible-base)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
